import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.email || !formData.message) {
      toast.error("Please fill in all fields!");
      return;
    }

    emailjs.send(
      'service_dqplbl5',
        'template_j1fcl3k',  
      {
        from_name: formData.name,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      },
      'SZahvFvLp4MvGIZLj'
      
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      toast.success("Message sent successfully!");
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: ''
      });
    })
    .catch((err) => {
      console.error('FAILED...', err);
      toast.error("Failed to send message. Please try again later.");
    });
  };

  return (
    <div className="contact-container p-4" style={{ fontFamily: 'sans-serif' }}>
      <ToastContainer />
      <h1 className="text-3xl font-bold text-[#854d0e] mb-4">CONTACT US</h1>

      <div className="grid md:grid-cols-2 gap-6 bg-white p-6 rounded-lg shadow-md">
        <form onSubmit={sendEmail} className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-700">GET IN TOUCH</h2>
          <div className="grid grid-cols-2 gap-4">
            <input 
              type="text" 
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name*" 
              className="border p-2 rounded" 
            />
            <input 
              type="text" 
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number*" 
              className="border p-2 rounded" 
            />
          </div>
          <input 
            type="email" 
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email*" 
            className="border w-full p-2 rounded" 
          />
          <textarea 
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your message" 
            className="border w-full p-2 rounded h-32"
          ></textarea>
          <button type="submit" className="bg-[#854d0e] text-white px-4 py-2 rounded w-full">
            SEND MESSAGE
          </button>
        </form>

        <div className="space-y-6">
          <p className="text-gray-600">
            If you have any questions, please feel free to get in touch via the form, email, or social media!
          </p>

          <div className="bg-gray-100 p-4 rounded">
            <h3 className="font-bold text-[#854d0e] mb-2">CONTACT INFORMATION</h3>
            <p>📞 773-365-1240</p>
            <p>📍 FashionHub wagholi, Pune</p>
            <p>✉️ office@fashionhub.com</p>
          </div>

          <div className="bg-gray-100 p-4 rounded">
            <h3 className="font-bold text-[#854d0e] mb-2">STYLE & TRENDS</h3>
            <p>🛍 Discover the latest drops</p>
            <p>🎁 Free styling consultation</p>
            <p>💬 24/7 Fashion Chat Support</p>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="mt-8">
        <iframe 
          title="Google map location"
          className="w-full h-72 rounded shadow"
          src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d3782.010257182714!2d73.9799883!3d18.5735763!3m2!1i1024!2i768!4f13.1!2m1!1sgh%20raisoni%20wagholi!5e0!3m2!1sen!2sin!4v1744397200947!5m2!1sen!2sin"  
          allowFullScreen 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
